'use strict'

const config = {
	extensionOptions: [30, 60],
	defaultTimeout: 1000
}

export default config
